import React, { useRef} from "react";
import { 
	RCCCheckBox
} from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { IRefIndicatorModal } from "src/components/ModalIndicator/interface";
import IndicatorModal from "src/components/ModalIndicator";
import { v4 } from "uuid";
import { css } from "styled-components";
import List from "src/components/List";
import { IEftba005, IUsersListGrouper } from "../interface";

const UsersListGrouper: React.FC<IUsersListGrouper> = ({
	usersList,
	setUsersList
}) => {

	const { translate } = useTranslation();
	const refModal = useRef<IRefIndicatorModal>(null);

	const handleSelected = (insert:boolean,indicator:IEftba005) => {
		setUsersList((prevState:Array<IEftba005>) => prevState.map((item) => {
			if(item.efa005Id === indicator.efa005Id){
				return {...item,selected:insert};
			}
			return item;
		}));
	};

	const headerRender = (row:any) => (
		<>
			<RCCCheckBox
				name={`seletedIndicator-${v4()}`}
				onChange={(e) => handleSelected(e.target.checked, row)}
				defaultChecked={row.selected}
				labelPosition="end"
				styleInline={{label:css`
					font-weight: bold;
					font-size: 0.85rem;
					color: var(--default-color-font);
				`}}
			/>
		</>
	);
	
	return (
		<>
			<List 
				data={usersList ?? []}
				columns={[
					{
						idColumn: "responsible",
						nameColumn: "",
						xs: 12,
						sm: 1,
						justify: "left",
						cellRenderer: headerRender
					},{
						idColumn: "efa005Nome",
						nameColumn: translate("Nome"),
						xs: 12,
						sm: 11,
						justify: "left"
					}
				]}
				layout="table"
			/>
			<IndicatorModal ref={refModal} /> 
		</>
	);
		
};
export default UsersListGrouper;
